import { getCurrentDate } from "@/helpers/Dates/DateHelpers";

function bytesToIntArray(base64: string): Uint8Array {
  const binaryString = window.atob(base64);
  const binaryLen = binaryString.length;
  const arrayBuffer = new Uint8Array(binaryLen);

  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    arrayBuffer[i] = ascii;
  }

  return arrayBuffer;
}

export function exportToPDF(bytes: string, fileName: string): void {
  if (!bytes) return;

  const data = bytesToIntArray(bytes);
  const file = new Blob([data], { type: "application/pdf" });
  const element = document.createElement("a");
  element.href = URL.createObjectURL(file);
  element.download = `${fileName}_${getCurrentDate().format(
    "YYYY-MM-DDHH:mm:ss"
  )}`
    .split(" ")
    .join("_");
  element.click();
}

export function exportExcelFile(bytes: string, fileName: string): void {
  const file = new Blob([bytesToIntArray(bytes)], {
    type: "data:application/octet-stream;encoding:utf-8",
  });
  const element = document.createElement("a");
  element.href = URL.createObjectURL(file);
  const fileNameWithDate = `${fileName}_${getCurrentDate().format(
    "YYYY-MM-DDHH:mm:ss"
  )}`
    .split(" ")
    .join("_");
  element.download = `${fileNameWithDate}.xlsx`;
  element.click();
}
